import { render, staticRenderFns } from "./PollList.vue?vue&type=template&id=70b3f83a&"
import script from "./PollList.vue?vue&type=script&lang=js&"
export * from "./PollList.vue?vue&type=script&lang=js&"
import style0 from "./PollList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports